import React, { useState } from "react";
import { AiOutlineClose } from "react-icons/ai";
import { GetPipelineStages } from "../../../apiServices";

function MobileNumberfilter({ setopenmobilenumber }) {
  const [inputValue, setInputValue] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [stage, setStage] = useState("");
  const [pipeLine, setPipeLine] = useState("");
  const [adminName, setAdminName] = useState("");
  const [openShowinfo, setopenShowinfo] = useState("");
  const [noDataMessage, setNoDataMessage] = useState(""); // State for no data message

  const handleInputChange = (e) => {
    const value = e.target.value;

    // Ensure the input is a number and is at most 10 digits long
    if (/^\d*$/.test(value) && value.length <= 10) {
      setInputValue(value);
      // Clear previous stage, pipeline data, and no data message when input changes
      setStage("");
      setPipeLine("");
      setNoDataMessage("");
      if (error) {
        setError(""); // Clear error when input changes
      }
    }
  };

  const handleSubmit = async () => {
    if (inputValue.trim() === "") {
      setError("Mobile number is required.");
    } else if (inputValue.length < 10) {
      setError("Mobile number must be exactly 10 digits.");
    } else if (inputValue.length > 10) {
      setError("Mobile number must be exactly 10 digits.");
    } else {
      setLoading(true);
      setError(""); // Clear error before API call
      setNoDataMessage(""); // Clear no data message

      try {
        const response = await GetPipelineStages(inputValue);
        if (response && response.statusCode === 200) {
          if (response.Stage && response.PipeLine) {
            setStage(response.Stage);
            setPipeLine(response.PipeLine);
            // setAdminName(response.AdminName);
            setopenShowinfo(false);
          } else {
            setNoDataMessage("Number Not Exists.");
            setopenShowinfo(false);
          }
        } else if (response.statuscode === 404) {
          setError("This number a new candidate.");
          setopenShowinfo(false);
        }
        // console.log("API Response:", response);
      } catch (apiError) {
        setopenShowinfo(true);
        console.error("API Error:", apiError);
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <div className="container  position-relative" style={{ width: "400px" }}>
      <div className="d-flex align-items-center justify-content-between">
        <div className="">
          <h6>Overall Mobile Number Search</h6>
        </div>
        <div className="">
          <button
            className="btn btn-danger"
            onClick={() => setopenmobilenumber(false)}
          >
            <AiOutlineClose />
          </button>
        </div>
      </div>
      <div className="row mt-3">
        <div className="col">
          <input
            type="text"
            className="form-control"
            placeholder="Enter mobile number"
            value={inputValue}
            onChange={handleInputChange}
            maxLength={10}
          />
          {error && <div className="text-danger mt-2">{error}</div>}
        </div>
      </div>
      <div className="row mt-2">
        <div className="col d-flex justify-content-end">
          <button
            className="btn btn-success"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? "Searching..." : "Search"}
          </button>
        </div>
      </div>
      {(stage || pipeLine || noDataMessage) && (
        <div className="row mt-1">
          <div className="col bg-light p-2 rounded-2">
            <p style={{ textAlign: "center" }}>
              {" "}
              <b>Candidate Stage</b>{" "}
            </p>
            {noDataMessage && <p className="text-danger">{noDataMessage}</p>}
            {pipeLine && (
              <p>
                <strong>PipeLine:</strong> {pipeLine}
              </p>
            )}
            {stage && (
              <p>
                <strong>Stage:</strong> {stage}
              </p>
            )}
            {/* {adminName &&(
              <p>
                <strong>Admin Name:</strong> {adminName}
              </p>
            )} */}
          </div>
        </div>
      )}

      {openShowinfo && (
        <div className="alert alert-info mt-3" role="alert">
          Pipeline stage is not searchable. Please check in candidate lead or
          registered.
        </div>
      )}
    </div>
  );
}

export default MobileNumberfilter;
